import PropTypes from 'prop-types'

import {
  Alert,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'

import styles from '../styles'
import ModalLayout from '../../../ui/modals/layout'

const shippingsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    shippingNumber: PropTypes.string.isRequired,
    senderCity: PropTypes.string.isRequired,
    destinationCity: PropTypes.string.isRequired,
    recipientName: PropTypes.string.isRequired,
  }),
).isRequired
const hasErrorPropType = PropTypes.bool

const cancelTablePropTypes = {
  rows: shippingsPropType,
  hasError: hasErrorPropType,
}
const CancelTable = ({ rows, hasError }) => {
  const t = useTranslations()
  return (
    <>
      <TableContainer sx={styles.tableContainer}>
        <Table>
          <TableHead sx={styles.tableHead}>
            <TableRow>
              <TableCell>{t('noun:shipping-number')}</TableCell>
              <TableCell>{t('noun:senderAddress2')}</TableCell>
              <TableCell>{t('noun:recipientAddress2')}</TableCell>
              <TableCell>{t('noun:recipientName')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.shippingNumber}>
                <TableCell>
                  <Typography variant="body2">
                    <strong>{row.shippingNumber}</strong>
                  </Typography>
                </TableCell>
                <TableCell>{row.senderCity}</TableCell>
                <TableCell className="truncate">
                  <span>{row.destinationCity}</span>
                </TableCell>
                <TableCell className="truncate">
                  <span>{row.recipientName}</span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {hasError ? (
        <Alert severity="error" sx={{ ...styles.alert, ...styles.alertError }}>
          <Typography variant="body2">{t('error:cancel-shipment')}</Typography>
        </Alert>
      ) : null}
    </>
  )
}
CancelTable.propTypes = cancelTablePropTypes

const propTypes = {
  shippings: shippingsPropType,
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  hasError: hasErrorPropType,
  isCancelling: PropTypes.bool,
}
const CancelShippingModalView = ({
  shippings,
  cancel,
  confirm,
  hasError,
  isCancelling,
}) => {
  const t = useTranslations()
  return (
    <ModalLayout
      isOpen
      wide
      title={t('message:you-are-going-to-cancel-shipment')}
      content={t('message:if-you-cancel-this-shipment-you-cant-recovery')}
      extraContent={<CancelTable hasError={hasError} rows={shippings} />}
      onClose={cancel}
      actions={
        <>
          <Button
            type="button"
            size="small"
            variant="outlined"
            onClick={cancel}
            disabled={isCancelling}
          >
            {t('action:cancel')}
          </Button>
          <Button
            type="submit"
            size="small"
            onClick={confirm}
            disabled={isCancelling}
          >
            {t('action:cancel-shipment', {
              count: shippings.length,
            })}
          </Button>
        </>
      }
    />
  )
}
CancelShippingModalView.propTypes = propTypes

export default CancelShippingModalView
